import Swup from 'swup';
import SwupPreloadPlugin from '@swup/preload-plugin';
import setFullHeight from './helpers/setFullHeight';
import { isTouch } from './helpers/detect-device';
import { IS_PHONE, BROWSER} from './helpers/consts';
import SimpleScrollbar from 'simple-scrollbar';
import accordeon from './helpers/accordeon';
import customSelect from './helpers/custom-select';
import { setScrolled } from './helpers/events';
import { scrollTo } from './helpers/scroll-to';
import header, { resetHeader, setColorHeader } from './components/general/header';
import megamenu, { resetMegamenu } from './components/general/megamenu';
import cursor from './components/general/cursor';
import hero from './components/hero';
import quote from './components/quote';
import insta from './components/insta';
import productsGrid from './components/products-grid';
import difference from './components/difference';
import style from './components/style';
import product from './components/product';
import popup, { popupsReset } from './components/popup';
import collectionStylesSlider from './components/sections/collection-styles-slider';
import cart from './components/cart';
import bis from './components/bis';
import collectionGrid from './components/sections/collection-grid';
import cardImgSlider from './components/sections/card-img-slider';
import filter from './components/sections/filter';
import registerForm from './components/sections/register-form';
import search from './components/sections/search';
import currencySwitcher from './components/sections/currency-switcher';
import asideSlider from './components/sections/aside-slider';
import account from './components/account';
import video from './components/sections/video';
import look from './components/sections/look';
import collectionStylesHover from './components/sections/collection-styles-hover';
// import wishlist from './components/wishlist'; // iwish
import wishlist from './components/general/wishlist'; // hulkapps
import addressFields from './components/sections/address-fields';
import colorSwatches from './components/sections/color-swatches';
import collectionHeaderScrolling from './components/sections/collection-header-scrolling';
import stickyUnderHeader from './components/sections/sticky-under-header';
import newsletterPopup from './components/sections/newsletter-popup';
import liveChat from './components/sections/live-chat';
import gw from './components/general/gw'; // cart gift wrap
import currency from './components/currency'; // cart gift wrap
import fitTextToViewport from './helpers/fit-text-to-viewport';
import contact from './components/sections/contact'; //contact form

export default () => {
	init();
	general();

	function init() {
		SimpleScrollbar.initAll();
		accordeon();

		// General

		popup();
		cart();
		bis();
		cursor();
		currency();
		customSelect({
			select: '.js-custom-select',
			dropdownProps: {
				showElements: 7
			}
		});
		document.querySelectorAll('[data-select-list]').forEach(elem => {
			SimpleScrollbar.initEl(elem);
		});
		scrollTo({
			selector: 'a[href^="#"]:not([href="#live-chat"])'
		});

		// Sections
		hero();
		quote();
		insta();
		difference();
		style();
		productsGrid();
		product();
		collectionStylesSlider();
		collectionGrid();
		cardImgSlider();
		filter();
		registerForm();
		search();
		currencySwitcher();
		asideSlider();
		account();
		video();
		look();
		collectionStylesHover();
		wishlist();
		addressFields();
		colorSwatches();
		collectionHeaderScrolling();
		stickyUnderHeader();
		// newsletterPopup();
		liveChat();
		fitTextToViewport();
		contact();

		// Animations
		setTimeout(() => {
		}, 10);
	}


	function general(){
		// Helpers
		if (!isTouch()) {
			document.body.classList.add('no-touch');
		}
		else {
			document.body.classList.add('touch');
		}

		if (IS_PHONE) {
			document.body.classList.add('is-phone');
			setScrolled(() => {
				document.documentElement.style.padding = '0'; // IOS fix
			});
		}
		document.body.classList.add(BROWSER.name);

		// Disable input zoom on iPhone
		if(navigator.userAgent.indexOf('iPhone') > -1 )
		{
			document
			.querySelector("[name=viewport]")
			.setAttribute("content","width=device-width, initial-scale=1, maximum-scale=1");
		}

		setFullHeight(); //Set VH variable for mobile safari 100VH, use scss mixin fullheight()

		header();
		megamenu();
		gw();
	}



	const swup = new Swup({
		plugins: [new SwupPreloadPlugin()]
	});

	swup.on('clickLink', ()=>{

	});
	swup.on('animationOutStart', ()=>{
		resetHeader();
		resetMegamenu();
		popupsReset();
	});
	swup.on('animationOutDone', ()=>{
		window.scrollTo(0, 0);
	});
	swup.on('contentReplaced', function(){
		init();
		setColorHeader();
	});
	swup.on('animationInStart', function(){
	});

	// Submitting search form using swup
	const searchform = document.querySelector(".search-popup__form-wrapper form");

	searchform.addEventListener('submit', function(event) {
		event.preventDefault();
		const query = searchform.querySelector('input[name="q"]').value;
		const searchURL = searchform.getAttribute('action') + "?q=" + encodeURIComponent(query);
        swup.loadPage({
            url: searchURL
        });
	});

};